import { request } from "../browser/request";
import { ds24cart_jsonp_args } from "./ds24cart_jsonp_args";
import { ds24cart_callback_add } from "./ds24cart_loader";
import { ds24cart_wait_start } from "./ds24cart_wait";
import { ds24_checkout_url } from "../common/ds24_checkout_url";

export function ds24cart_add_exec( product_id: number, quantity?: number, quantity_readonly = false )
{
    if (typeof quantity === 'undefined')
    {
        quantity = 1;
    }

    const quantity_readonly_parameter = (quantity_readonly ? 1 : 0);

    ds24cart_wait_start();

    const addUrl = ds24_checkout_url() + '/cart/add/' + product_id + '?' + ds24cart_jsonp_args() + '&quantity='+quantity + '&quantity_readonly=' + quantity_readonly_parameter;

    request({
        url: addUrl,
        dataType: 'jsonp',
        success: ds24cart_callback_add
    });

    return false;
}